(() => {
  const initHeader = (root) => {
    if (!root || root.dataset.modReady === 'true') return;
    root.dataset.modReady = 'true';

    const section = root.closest('.shopify-section') || root.parentElement;
    const mega = root.querySelector('[data-mod-mega]');
    const megaTrigger = root.querySelector('[data-mod-mega-trigger]');
    const tabs = Array.from(root.querySelectorAll('[data-mod-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-mod-panel]'));
    const mobileMenu = root.querySelector('[data-mod-mobile-menu]');
    const mobileOverlay = root.querySelector('[data-mod-mobile-overlay]');
    const mobileOpen = root.querySelector('[data-mod-mobile-open]');
    const mobileClose = root.querySelector('[data-mod-mobile-close]');
    const mobileAccordionToggles = Array.from(root.querySelectorAll('[data-mod-mobile-accordion]'));
    const mobileSearchToggle = root.querySelector('[data-mod-mobile-search-toggle]');
    const mobileSearch = root.querySelector('[data-mod-mobile-search]');
    const mobileSearchInput = root.querySelector('[data-mod-mobile-search-input]');
    const stickyType = root.dataset.stickyType || 'none';

    let megaCloseTimer = null;
    let lastScrollY = window.scrollY;
    let lastFocusedElement = null;
    let stickyStart = 0;
    let stickyPlaceholder = null;

    const syncStickyPlaceholder = () => {
      if (!section || !stickyPlaceholder) return;
      const isFixed = section.classList.contains('mod-header-section--fixed');
      stickyPlaceholder.style.height = isFixed ? `${section.offsetHeight}px` : '0px';
    };

    const updateStickyStart = () => {
      if (!section || !stickyPlaceholder) return;
      const reference = section.classList.contains('mod-header-section--fixed') ? stickyPlaceholder : section;
      stickyStart = reference.getBoundingClientRect().top + window.scrollY;
      syncStickyPlaceholder();
    };

    const setActiveTab = (id) => {
      if (!id) return;
      tabs.forEach((tab) => {
        const active = tab.dataset.modTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.modPanel === id);
      });
    };

    const openMega = () => {
      if (!mega || !megaTrigger || window.matchMedia('(max-width: 989px)').matches) return;
      if (megaCloseTimer) window.clearTimeout(megaCloseTimer);
      mega.classList.add('is-open');
      mega.setAttribute('aria-hidden', 'false');
      megaTrigger.setAttribute('aria-expanded', 'true');
    };

    const closeMega = () => {
      if (!mega || !megaTrigger) return;
      mega.classList.remove('is-open');
      mega.setAttribute('aria-hidden', 'true');
      megaTrigger.setAttribute('aria-expanded', 'false');
    };

    const scheduleMegaClose = () => {
      if (megaCloseTimer) window.clearTimeout(megaCloseTimer);
      megaCloseTimer = window.setTimeout(closeMega, 130);
    };

    if (megaTrigger && mega) {
      megaTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (mega.classList.contains('is-open')) closeMega();
        else openMega();
      });
      megaTrigger.addEventListener('mouseenter', openMega);
      megaTrigger.addEventListener('focus', openMega);
      mega.addEventListener('mouseenter', () => {
        if (megaCloseTimer) window.clearTimeout(megaCloseTimer);
      });
      megaTrigger.addEventListener('mouseleave', scheduleMegaClose);
      mega.addEventListener('mouseleave', scheduleMegaClose);
    }

    tabs.forEach((tab) => {
      const activate = () => setActiveTab(tab.dataset.modTab);
      tab.addEventListener('mouseenter', activate);
      tab.addEventListener('focus', activate);
      tab.addEventListener('click', activate);
    });

    const setMobileAccordion = (button, expanded) => {
      if (!button) return;
      const submenuId = button.getAttribute('aria-controls');
      const submenu = submenuId ? document.getElementById(submenuId) : null;
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.classList.toggle('is-open', expanded);
      if (submenu) submenu.hidden = !expanded;
    };

    const collapseMobileAccordionTree = (scope = mobileMenu) => {
      if (!scope) return;
      scope.querySelectorAll('[data-mod-mobile-accordion]').forEach((button) => {
        setMobileAccordion(button, false);
      });
    };

    const closeSiblingAccordions = (button) => {
      const currentItem = button.closest('.mod-mobile-menu__item');
      const list = currentItem ? currentItem.parentElement : null;
      if (!list) return;

      Array.from(list.children).forEach((item) => {
        if (item === currentItem) return;
        const siblingButton = Array.from(item.children).find((child) => child.matches && child.matches('[data-mod-mobile-accordion]'));
        if (!siblingButton) return;
        setMobileAccordion(siblingButton, false);
        item.querySelectorAll('[data-mod-mobile-accordion]').forEach((nestedButton) => {
          if (nestedButton !== siblingButton) setMobileAccordion(nestedButton, false);
        });
      });
    };

    const openMobileMenu = () => {
      if (!mobileMenu || !mobileOverlay) return;
      closeMega();
      lastFocusedElement = document.activeElement;
      collapseMobileAccordionTree();
      mobileMenu.classList.add('is-open');
      mobileOverlay.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (mobileOpen) mobileOpen.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('mod-mobile-menu-open');
      window.setTimeout(() => {
        const first = mobileMenu.querySelector('[data-mod-mobile-close]');
        if (first) first.focus({ preventScroll: true });
      }, 40);
    };

    const closeMobileMenu = () => {
      if (!mobileMenu || !mobileOverlay) return;
      mobileMenu.classList.remove('is-open');
      mobileOverlay.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (mobileOpen) mobileOpen.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mod-mobile-menu-open');
      window.setTimeout(() => collapseMobileAccordionTree(), 280);
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus({ preventScroll: true });
      }
    };

    if (mobileOpen) mobileOpen.addEventListener('click', openMobileMenu);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

    mobileAccordionToggles.forEach((button) => {
      button.addEventListener('click', () => {
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        closeSiblingAccordions(button);
        setMobileAccordion(button, willOpen);
      });
    });

    if (mobileSearchToggle && mobileSearch) {
      mobileSearchToggle.addEventListener('click', () => {
        const willOpen = mobileSearch.hasAttribute('hidden');
        if (willOpen) {
          mobileSearch.removeAttribute('hidden');
          mobileSearchToggle.setAttribute('aria-expanded', 'true');
          window.setTimeout(() => mobileSearchInput && mobileSearchInput.focus(), 20);
        } else {
          mobileSearch.setAttribute('hidden', '');
          mobileSearchToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeMega();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMega();
        closeMobileMenu();
        if (mobileSearch && !mobileSearch.hasAttribute('hidden')) {
          mobileSearch.setAttribute('hidden', '');
          if (mobileSearchToggle) mobileSearchToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });

    const onScroll = () => {
      if (!section || stickyType === 'none') return;
      const currentY = Math.max(0, window.scrollY);
      if (!section.classList.contains('mod-header-section--fixed')) {
        stickyStart = section.getBoundingClientRect().top + currentY;
      }
      const shouldFix = currentY >= stickyStart;

      section.classList.toggle('mod-header-section--fixed', shouldFix);
      section.classList.toggle('mod-header-section--scrolled', shouldFix && currentY > stickyStart + 8);
      syncStickyPlaceholder();

      if (!shouldFix) {
        section.classList.remove('mod-header-section--hidden');
      } else if (stickyType === 'on_scroll_up') {
        const movingDown = currentY > lastScrollY;
        const shouldHide = movingDown && currentY > stickyStart + 120 && !(mobileMenu && mobileMenu.classList.contains('is-open'));
        section.classList.toggle('mod-header-section--hidden', shouldHide);
      } else {
        section.classList.remove('mod-header-section--hidden');
      }
      lastScrollY = currentY;
    };

    if (stickyType !== 'none' && section && section.parentNode) {
      stickyPlaceholder = document.createElement('div');
      stickyPlaceholder.className = 'mod-header-sticky-placeholder';
      stickyPlaceholder.setAttribute('aria-hidden', 'true');
      stickyPlaceholder.style.height = '0px';
      section.parentNode.insertBefore(stickyPlaceholder, section);
      updateStickyStart();
      window.addEventListener('scroll', onScroll, { passive: true });
      if ('ResizeObserver' in window) {
        const stickyResizeObserver = new ResizeObserver(() => {
          syncStickyPlaceholder();
        });
        stickyResizeObserver.observe(section);
      }
      onScroll();
    }

    window.addEventListener('resize', () => {
      if (stickyType !== 'none') updateStickyStart();
      if (window.matchMedia('(min-width: 990px)').matches) {
        closeMobileMenu();
        if (mobileSearch && !mobileSearch.hasAttribute('hidden')) {
          mobileSearch.setAttribute('hidden', '');
          if (mobileSearchToggle) mobileSearchToggle.setAttribute('aria-expanded', 'false');
        }
      } else {
        closeMega();
      }
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-mod-header]').forEach(initHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
